import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KeyboardCapslockIcon(props: IconProps) {
    return <Icon {...props} iconKey={"keyboard_capslock"}/>
}
